import { SupabaseServiceView } from "../../../server/supabase/base-supabase-service";

import type { Database } from "../../../__definitions__/database-definitions";

export type OptedOut = Database["public"]["Views"]["opted_out"]["Row"];

export class SupabaseOptedOutService extends SupabaseServiceView<"opted_out"> {
  table = "opted_out" as const;
}
